import {
  BrandingKey,
  BuilderKey,
  ControlKey,
  GuardKey,
  MicrositePageKey,
  PreviewKey,
  PublishKey,
  TabsKey
} from '../../TModules';
import { MicrositeTranslations } from '../en/translations';

export const translations: MicrositeTranslations = {
  [MicrositePageKey]: {
    OtherSettings: 'Autres paramètres',
    SettingUpdated: 'Paramètre mis à jour',
    FailedToUpdateSetting: 'Échec de la mise à jour du paramètre',
    Loading: 'Chargement',
    LoadError: 'Échec du chargement des paramètres',
    AllowCustomNickname: 'Permettre aux utilisateurs de définir un surnom personnalisé',
    AllowCustomNicknameSubtext:
      "Lorsqu'il est activé, les utilisateurs du microsite peuvent définir un surnom unique sur leur profil qui sera utilisé comme leur identifiant alternatif."
  },
  [TabsKey]: {
    Details: 'Détails',
    Branding: 'Image de marque',
    Microsite: 'Microsite',
    ControlSettings: 'Paramètres de contrôle'
  },
  [BrandingKey]: {
    Cards: {
      BrandIdentity: 'Identité de marque',
      Typography: 'Typographie',
      BackgroundColors: 'Couleurs d’arrière-plan',
      TextColors: 'Couleurs du texte',
      SemanticColors: 'Couleurs sémantiques',
      AccentColors: 'Couleurs d’accent',
      Others: 'Autres',
      Buttons: 'Boutons'
    },
    Tooltips: {
      BrandIdentity:
        'Configurez l’identité de marque principale utilisée dans toute l’expérience, y compris le nom de l’application, les couleurs de marque, le logo et le rayon de bordure global.',
      Typography:
        'Définissez la famille de polices utilisée dans toute l’expérience pour une typographie cohérente et lisible.',
      BackgroundColors:
        'Configurez les couleurs d’arrière-plan des zones clés de l’expérience, y compris les sections, l’en-tête de l’application, l’arrière-plan de l’application et les zones hero.',
      TextColors:
        'Définissez les couleurs des titres, du corps de texte, du texte secondaire et des liens pour un style de texte cohérent et lisible.',
      SemanticColors:
        'Définissez les couleurs standard utilisées pour communiquer un sens et un statut, comme succès, avertissement, erreur, information, neutre et promotionnel.',
      AccentColors:
        'Configurez des couleurs complémentaires utilisées pour les mises en évidence, les éléments visuels et les composants d’interface de l’expérience.',
      Others:
        'Configurez des couleurs complémentaires pour les éléments d’interface tels que les icônes principales et secondaires.',
      Buttons:
        'Configurez l’apparence des boutons principaux et secondaires, y compris le remplissage, le texte, la bordure, les états désactivés, la hauteur et le rayon de bordure.'
    },
    Fields: {
      title: 'Nom de l’application',
      primary_color: 'Couleur principale de la marque',
      secondary_color: 'Couleur secondaire de la marque',
      logo: 'Image du logo',
      border_radius: 'Rayon de bordure global',
      font: 'Famille de polices',
      bg_primary_color: 'Principale',
      bg_secondary_color: 'Secondaire',
      bg_tertiary_color: 'Tertiaire',
      bg_alternative_color: 'Alternative',
      header_color: 'En-tête de l’application',
      app_bg_color: 'Arrière-plan de l’application',
      font_color: 'Principale',
      text_secondary_color: 'Secondaire',
      text_tertiary_color: 'Tertiaire',
      link_color: 'Lien',
      success_color: 'Succès',
      warning_color: 'Avertissement',
      error_color: 'Erreur',
      information_color: 'Information',
      neutral_color: 'Neutre',
      promotional_color: 'Promotionnel',
      accent_color: 'Accent 1',
      accent_2_color: 'Accent 2',
      accent_3_color: 'Accent 3',
      accent_4_color: 'Accent 4',
      accent_5_color: 'Accent 5',
      accent_6_color: 'Accent 6',
      icon_primary_color: 'Icône principale',
      icon_secondary_color: 'Icône secondaire',
      CTA_button_bg_color: 'Remplissage',
      CTA_button_text_color: 'Couleur du texte',
      CTA_button_disabled_bg_color: 'Remplissage désactivé',
      CTA_button_disabled_text_color: 'Texte désactivé',
      secondary_button_bg_color: 'Remplissage',
      secondary_button_border_color: 'Bordure',
      secondary_button_text_color: 'Couleur du texte',
      secondary_button_disabled_bg_color: 'Remplissage désactivé',
      secondary_button_disabled_border_color: 'Bordure désactivée',
      secondary_button_disabled_text_color: 'Texte désactivé',
      button_height: 'Hauteur du bouton (px)',
      button_border_radius: 'Rayon de bordure (px)'
    },
    Help: {
      PrimaryColor:
        'La couleur principale est utilisée par exemple pour la mise en évidence des barres de progression',
      Logo: 'PNG ou SVG, 120 × 30 px recommandé',
      BorderRadius: 'Appliqué globalement aux cartes, champs de saisie et badges.'
    },
    Radius: {
      Small: 'Petit - 4px',
      Medium: 'Moyen - 8px',
      Large: 'Grand - 16px',
      Sharp: 'Carré - 0px'
    },
    Px: 'px',
    Replace: 'Remplacer',
    TooltipLabel: 'À propos de {{section}}',
    ResetToDefault: 'Rétablir les valeurs par défaut',
    Reset: 'Réinitialiser',
    Save: 'Enregistrer les modifications',
    Sample: 'Exemple',
    SampleText: 'Portez ce vieux whisky au juge blond',
    UnsupportedFont: '{{font}} (non prise en charge)',
    Preview: 'Aperçu',
    PreviewHeading: 'Texte de titre',
    PreviewBody: 'Exemple de corps de texte',
    PreviewCaption: 'Légende ou texte d’aide',
    PreviewLink: 'Texte du lien',
    PrimaryButton: 'Bouton principal',
    SecondaryButton: 'Bouton secondaire',
    SharedSizing: 'Dimensions communes',
    ButtonPrimary: 'Principal',
    ButtonSecondary: 'Secondaire',
    ButtonSmall: 'Petit',
    ButtonDisabled: 'Désactivé',
    Errors: {
      Required: 'Ce champ est obligatoire',
      invalid_hex: 'Saisissez une couleur HEX valide, par ex. #0284C7',
      logo_required: "L'image du logo est obligatoire",
      unsupported_font: 'Cette police n’est plus prise en charge. Choisissez une autre police.',
      invalid_integer: 'Saisissez un nombre entier supérieur ou égal à 0'
    },
    Toasts: {
      Saved: 'Branding enregistré',
      SaveFailed: 'Impossible d’enregistrer le branding. Veuillez réessayer.',
      FixErrors: 'Veuillez corriger les champs signalés avant d’enregistrer.'
    },
    Load: {
      Failed: 'Impossible de charger les paramètres de branding.',
      Retry: 'Réessayer'
    }
  },
  [BuilderKey]: {
    StartingPoint: {
      Title: 'Créez votre microsite',
      Subtitle: 'Choisissez comment lancer votre portail d’expérience client.',
      TemplateTitle: 'Commencer avec un modèle',
      TemplateDescription:
        'Choisissez parmi des profils de mise en page prédéfinis conçus pour la fidélité et les mécaniques de points.',
      BlankTitle: 'Commencer avec une page vierge',
      BlankDescription:
        'Commencez avec un espace de travail vide et faites glisser les composants dans le builder manuellement.',
      Continue: 'Continuer',
      ReadOnly:
        'Vous disposez d’un accès en lecture seule et ne pouvez donc pas créer le microsite.'
    },
    Existing: {
      Title: 'Votre microsite enregistré',
      Published: 'Publié : {{name}}',
      PublishedAt: 'Publié le {{date}}',
      Draft: 'Brouillon : {{name}}',
      DraftUpdatedAt: 'Dernier enregistrement le {{date}}',
      Label: '{{template}} · {{theme}}',
      BlankCanvas: 'Canevas vierge',
      BrandingTheme: 'Thème de l’image de marque globale',
      TemplateTheme: 'Thème par défaut du modèle',
      View: 'Afficher',
      OverwriteDraft: 'Remplacer le modèle brouillon',
      OverwritePublished: 'Remplacer le modèle publié',
      Duplicate: {
        Title: 'Ce modèle existe déjà',
        Published:
          'Ce modèle est déjà publié. Pour le modifier, cliquez sur Afficher, modifiez le modèle existant et publiez-le à nouveau.',
        Draft:
          'Ce modèle existe déjà en tant que brouillon. Pour le modifier, cliquez sur Afficher et modifiez le brouillon existant.',
        Close: 'OK'
      },
      Confirm: {
        Title: 'Remplacer votre page enregistrée ?',
        Published:
          'Vous avez déjà un modèle publié ({{current}}). Commencer avec {{next}} remplacera votre brouillon enregistré lors de l’enregistrement, et la page en ligne lors de la publication. Continuer ?',
        Draft:
          'Vous avez déjà un brouillon enregistré ({{current}}). Commencer avec {{next}} remplacera votre brouillon enregistré lors de l’enregistrement. Continuer ?',
        Continue: 'Continuer',
        Cancel: 'Annuler'
      }
    },
    Templates: {
      Title: 'Choisir un modèle de thème',
      Subtitle: 'Sélectionnez un modèle pré-intégré pour définir votre expérience de récompenses.',
      Back: 'Retour',
      Empty: 'Aucun modèle n’est disponible.',
      UseSelected: 'Utiliser le modèle sélectionné',
      Descriptions: {
        point_utilization:
          'Mécanismes d’utilisation instantanée des points et affichage du catalogue.',
        hybrid_driven: 'Points, défis et statistiques de marque en équilibre.',
        progress_driven: 'Étapes ludiques, niveaux et indicateurs de points.',
        reward_driven: 'Récompenses tendance et offres à proximité géolocalisées.'
      }
    },
    ThemeSource: {
      Title: 'Sélectionner la source du thème',
      Description: 'Choisissez l’origine des couleurs et de la typographie de ce modèle.',
      TemplateDefault: 'Utiliser les paramètres du thème par défaut du modèle',
      TemplateDefaultHelp:
        'Appliquer les couleurs et la typographie prédéfinies du modèle à toutes les sections.',
      Branding: 'Utiliser les paramètres du branding global',
      BrandingHelp:
        'Appliquer les dernières couleurs et typographie de branding enregistrées à toutes les sections.',
      BrandingBlocked:
        'Le branding global est incomplet ou invalide. Complétez-le et enregistrez-le d’abord dans l’onglet Image de marque.',
      GoToBranding: 'Aller à l’onglet Image de marque',
      Confirm: 'Appliquer',
      Cancel: 'Annuler'
    },
    Editor: {
      PageStructure: 'Structure de la page',
      Sections: 'Sections',
      ReorderHint: 'Faites glisser les sections pour les réorganiser',
      AddSection: 'Ajouter une section',
      AddSectionHint: 'Faites glisser les sections dans le canevas ou cliquez pour les ajouter',
      Settings: 'Paramètres de {{name}}',
      Layout: 'Mise en page',
      LayoutUnavailable: 'Aucune mise en page n’est encore disponible pour cette section.',
      SelectSection: 'Sélectionnez une section à configurer.',
      Card: 'Carte {{number}}',
      NearbyReward: {
        RewardDistance: 'Distance de la récompense'
      },
      CategoryReward: {
        RewardsCategoryFilter: 'Filtre de catégories de récompenses',
        RewardsCategoryFilterTooltip:
          'Affiche toutes les catégories configurées pour filtrer les récompenses.'
      },
      PointRedemption: {
        DisplayImage: 'Image affichée',
        DisplayImageHint: '{{size}}px par {{size}}px recommandé',
        TitleText: 'Texte du titre',
        SubtitleText: 'Texte du sous-titre',
        SemanticText: 'Texte sémantique',
        PointsText: 'Texte des points'
      },
      TransferPoints: {
        DisplayImage: 'Image affichée',
        DisplayImageHint: '{{size}}px par {{size}}px recommandé',
        BackgroundNumber: 'Arrière-plan {{number}}',
        TitleText: 'Texte du titre',
        SubtitleText: 'Texte du sous-titre'
      },
      AvailableChallenges: {
        CampaignTitle: 'Titre de la campagne',
        ChallengeTypeFilter: 'Filtre de types de défis',
        ChallengeTypeFilterTooltip:
          'Affiche tous les types de défis pour filtrer les défis disponibles.'
      },
      GamesAndChallenges: {
        AppearanceTooltips: {
          Accent1: 'Arrière-plan du badge Nouveau',
          Accent2: 'Arrière-plan du badge À venir',
          Accent3: 'Arrière-plan du badge de date de fin',
          Semantic1: 'Texte du badge Nouveau',
          Semantic2: 'Texte du badge À venir',
          Semantic3: 'Texte du badge de date de fin'
        },
        CardBackground: 'Arrière-plan de la carte',
        ChallengeTitle: 'Titre du défi',
        DescriptionText: 'Texte de description',
        AccentNumber: 'Accent {{number}}',
        SemanticNumber: 'Sémantique {{number}}',
        Description: 'Description',
        NewBadge: 'Badge Nouveau',
        UpcomingBadge: 'Badge À venir',
        EndDateBadge: 'Badge de date de fin',
        CarouselContentTooltip:
          'Choisissez le nombre de défis à afficher dans le carrousel. Laissez ce champ vide pour afficher tous les défis avec un défilement infini.',
        ChallengesToDisplay: 'Défis à afficher',
        SeeAllHint:
          'Redirige les utilisateurs vers la liste des défis pour afficher tous les défis.'
      },
      FeaturedReward: {
        AccentTooltip: 'Arrière-plan du badge',
        SemanticTooltip: 'Texte du badge',
        Visibility: 'Visibilité',
        PointsBadge: 'Badge de points',
        RewardTitle: 'Titre de la récompense',
        MerchantName: 'Nom du commerçant',
        SellingDate: 'Date de vente',
        CarouselContent: 'Contenu du carrousel',
        CarouselContentTooltip:
          'Choisissez le nombre de récompenses à afficher dans le carrousel. Laissez vide pour afficher toutes les récompenses avec un défilement infini.',
        RewardsToDisplay: 'Récompenses à afficher',
        ShowSeeAll: 'Afficher le bouton « Tout voir »',
        SeeAllHint:
          'Dirige les utilisateurs vers la liste des récompenses pour toutes les consulter.'
      },
      SectionSettings: {
        Title: 'Paramètres de section',
        ShowTitle: 'Afficher le titre',
        TitleText: 'Texte du titre',
        TranslateTitle: 'Traduire le titre',
        Translation: 'Traduction',
        BackToSettings: 'Retour aux paramètres',
        TranslationLanguages: {
          en: 'Anglais',
          ar: 'Arabe',
          fr: 'Français',
          id: 'Indonésien',
          it: 'Italien',
          vi: 'Vietnamien'
        },
        TextColor: 'Couleur du texte',
        SectionBackground: 'Arrière-plan de la section',
        BackgroundColor: 'Couleur de fond',
        Margin: 'Marge',
        Top: 'Haut',
        Bottom: 'Bas'
      },
      Appearance: {
        Title: 'Apparence',
        ResetToTemplate: 'Rétablir le modèle',
        ResetToBranding: 'Rétablir le branding',
        Background: 'Arrière-plan',
        CardBackground: 'Fond de la carte',
        CardBackground1: 'Fond de la carte 1',
        CardBackground2: 'Fond de la carte 2',
        RankBackground: 'Fond du classement',
        Alternate: 'Alternatif',
        TextNumber: 'Texte {{number}}',
        ActiveStreakTextTooltips: {
          Text1: 'Nombre de jours de série',
          Text2: 'Activité de série',
          Text3: 'Description'
        },
        LeaderboardTextTooltips: {
          Text1: 'Rang',
          Text2: 'Libellé',
          Text3: 'Titre du classement'
        },
        Text: 'Texte',
        TextColor: 'Texte',
        ExpiryTextColor: 'Sémantique',
        Accent: 'Accent',
        Semantic: 'Sémantique',
        Icon: 'Icône',
        ButtonType: 'Type de bouton',
        PrimaryButton: 'Bouton principal',
        SecondaryButton: 'Bouton secondaire'
      }
    },
    Panel: {
      Title: 'Sections',
      Add: 'Ajouter une section',
      Empty: 'Aucune section ajoutée pour le moment.',
      MoveUp: 'Déplacer {{name}} vers le haut',
      MoveDown: 'Déplacer {{name}} vers le bas',
      Remove: 'Supprimer {{name}}',
      LayoutLabel: 'Mise en page de {{name}}',
      Layouts: {
        Carousel: 'Carrousel',
        List: 'Liste',
        Grid: 'Grille'
      },
      QuickLinksLabel: 'Liens rapides',
      QuickLinksPlaceholder: 'Sélectionner des liens rapides',
      QuickActionLabel: 'Action {{number}}',
      QuickActionPlaceholder: 'Sélectionner un lien rapide',
      QuickActionUpload: 'Importer',
      QuickActionUploaded: 'Importée',
      QuickActionUploadLabel: 'Importer une image pour l’action {{number}}',
      QuickActionImageHint: '48 px sur 48 px recommandé',
      QuickActionImageTooLarge: 'Les images ne doivent pas dépasser {{size}} Ko',
      QuickActionImageType: 'Importez une image PNG, JPEG ou WebP',
      QuickActionsReset: 'Réinitialiser au modèle',
      TagLabel: 'Tag',
      TagPlaceholder: 'Sélectionner un tag',
      TagsLabel: 'Tags',
      TagsInfo: 'Affiche tous les tags configurés',
      TagsEmpty: 'Aucun tag configuré.',
      TagUnavailable: 'Le tag sélectionné n’est plus disponible. Sélectionnez un autre tag.',
      CategoryFilter: 'Filtre de catégorie',
      CampaignTypeFilter: 'Filtre de type de campagne',
      SectionIssue: 'Cette section doit être corrigée avant de pouvoir être publiée.'
    },
    Canvas: {
      Label: 'Canevas de la page d’accueil',
      Empty:
        'Aucune section pour le moment. Ajoutez des sections pour construire votre page d’accueil.',
      SelectTag: 'Sélectionnez un tag pour prévisualiser cette section.',
      NoItems: 'Aucun élément à afficher dans cette section pour le moment.',
      LoadFailed: 'Impossible de charger les éléments de l’aperçu.',
      StaticSection: 'Affiché avec les données client en direct sur le microsite.',
      LoyaltyCardTitle: 'Solde de points',
      LoyaltyCardHint: 'Le niveau et les points du client apparaissent ici.',
      QuickActionSample1: 'Action rapide 1',
      QuickActionSample2: 'Action rapide 2',
      QuickActionSample3: 'Action rapide 3',
      QuickActionSample4: 'Action rapide 4',
      QuickActionsHeadingCard1: 'Profitez au maximum de vos points',
      QuickActionsHeadingCard2: 'Le carnaval des récompenses est là !',
      RewardSampleTitle1: 'Visite privée du vignoble',
      RewardSampleTitle2: 'Week-end spa',
      RewardSampleTitle3: 'Dîner pour deux',
      RewardSampleMerchant: 'Nom du commerçant',
      RewardSampleDistance: '0,3 km',
      CategoryRewardsAllRewards: 'Toutes les récompenses',
      RewardCta: 'Afficher',
      ChallengeSampleTitle1: 'Défi pas de la semaine',
      ChallengeSampleTitle2: 'Tournez et gagnez',
      ChallengeSampleTitle3: 'Check-in quotidien',
      ChallengeSampleDescription: 'Relevez-le pour gagner des points bonus',
      ActiveStampSampleTitle: 'Titre de la campagne de tampons',
      ActiveRaffleSampleTitle: 'Titre de la tombola',
      ActiveStamps: 'Tampons',
      ActiveStampProgress: '{{current}}/{{total}} tampons',
      ActiveTickets: '{{count}} billets',
      ActiveResume: 'Reprendre',
      AllChallenges: 'Tous les défis',
      ChallengeEndsInDay: 'Se termine dans {{count}} jour',
      ChallengeEndsInDays: 'Se termine dans {{count}} jours',
      StreakSampleTitle1: 'Connexion',
      StreakSampleTitle2: 'Transactions',
      StreakSampleTitle3: 'Check-in quotidien',
      StreakSampleRule1: "Connectez-vous 7 jours d'affilée",
      StreakSampleRule2: '2 connexions par mois pendant 12 mois',
      StreakSampleRule3: 'Faites un check-in 10 jours de suite',
      StreakSampleUnit1: 'connexions',
      StreakSampleUnit2: 'transactions',
      StreakSampleUnit3: 'check-ins',
      StreakUnitDays: 'jours',
      StreakLabel: 'Votre série',
      StreakWeekProgress: '{{current}} / {{target}} {{unit}} cette semaine',
      StreakRemaining: 'Encore {{count}} {{unit}} cette semaine pour rester sur la bonne voie',
      StreakOnTrack: 'Vous êtes sur la bonne voie cette semaine',
      PointRedemptionSampleTitle: 'Points en cashback',
      PointRedemptionSampleDescription: 'Échangez vos points contre du cashback',
      PointRedemptionValue: '{{points}} points = {{value}}',
      PointRedemptionValueShort: '{{points}} pts = {{value}}',
      PointRedemptionUnit: 'Points',
      PointRedemptionAccumulated: 'Points cumulés',
      PointRedemptionCashback: 'Valeur du cashback',
      PointRedemptionCta: 'Échanger',
      TransferPointsSampleTitle: 'Transférer des points',
      TransferPointsSampleDescription: 'Partagez des points avec vos proches',
      TransferPointsCta: 'Transférer',
      Points: '{{points}} pts',
      SeeAll: 'Voir tout',
      ShowLess: 'Afficher moins',
      GoToItem: "Aller à l'élément {{index}}",
      Distance: 'À 1,2 km',
      New: 'Nouveau',
      Upcoming: 'À venir',
      EndsOn: 'Se termine le {{date}}',
      LeaderboardRankLabel: 'Votre rang au classement',
      LeaderboardSampleTitle1: 'Course aux points du mois',
      LeaderboardSampleTitle2: "Sprint d'achats du week-end",
      LeaderboardSampleTitle3: 'Champions du parrainage',
      LeaderboardSampleRank: 'Rang {{rank}}e',
      LeaderboardFeaturedRankSuffix: 'e',
      LeaderboardSampleRankSuffix: 'e'
    }
  },
  [PublishKey]: {
    Load: {
      Failed: 'Impossible de charger la page d’accueil.',
      Retry: 'Réessayer'
    },
    Actions: {
      Label: 'Actions de la page d’accueil',
      SaveDraft: 'Enregistrer',
      Publish: 'Publier',
      ChangeStartingPoint: 'Changer de point de départ',
      Unsaved: 'Modifications non enregistrées',
      DraftSaved: 'Brouillon enregistré {{date}}',
      Published: 'Publié {{date}}',
      NotPublished: 'Pas encore publié'
    },
    Toasts: {
      DraftSaved: 'Brouillon enregistré.',
      Published: 'Page d’accueil publiée.',
      AlreadyPublished: 'Déjà publié. Aucune modification à publier.',
      SaveFailed: 'Impossible d’enregistrer le brouillon. Veuillez réessayer.',
      PublishFailed: 'Impossible de publier la page d’accueil. Veuillez réessayer.',
      Invalid: 'Corrigez les problèmes signalés et réessayez.'
    },
    Issues: {
      Title: 'Corrigez ces problèmes avant de publier',
      GoToBranding: 'Aller à l’onglet Image de marque',
      Section: '{{name}} : {{issue}}',
      UnsupportedAttribute: 'Contient un paramètre non pris en charge.',
      UnknownSection: 'Cette section n’est plus disponible.',
      DuplicateSection: 'Cette section est ajoutée plusieurs fois.',
      InvalidLayout: 'La mise en page sélectionnée n’est pas valide.',
      LayoutNotAllowed: 'Cette section ne prend pas en charge de mise en page.',
      UnknownQuickLink: 'Un lien rapide sélectionné n’est plus disponible.',
      DuplicateQuickLink: 'Un lien rapide est sélectionné plusieurs fois.',
      ModuleDisabled: 'Le module de cette section est désactivé.',
      InvalidTag: 'Le tag sélectionné n’est pas valide.',
      TagRequired: 'Sélectionnez un tag pour cette section.',
      TagUnavailable: 'Le tag sélectionné n’est plus disponible. Sélectionnez un autre tag.',
      ThemeIncomplete: 'Le thème du modèle est incomplet. Utilisez plutôt le Branding global.',
      BrandingInvalid:
        'Le Branding global contient des valeurs non valides. Corrigez-les dans l’onglet Image de marque.',
      BrandingIncomplete:
        'Il manque des valeurs obligatoires dans le Branding global : {{fields}}.',
      Generic: 'Cette configuration n’est pas valide.'
    }
  },
  [PreviewKey]: {
    Open: 'Aperçu',
    Title: 'Aperçu de la page d’accueil',
    Close: 'Fermer',
    Notice: 'Aperçu de vos modifications en cours. Rien ici n’est publié.'
  },
  [ControlKey]: {
    Title: 'Paramètres de contrôle',
    Description:
      'Activez ou désactivez les fonctionnalités du microsite. Les modifications s’appliquent immédiatement.',
    Flags: {
      show_quest: 'Quêtes',
      show_nearme: 'À proximité',
      rewards_carousel: 'Carrousel de récompenses',
      show_point_transfer: 'Transfert de points',
      show_popup_campaign: 'Campagnes pop-up',
      show_reward_nav_button: 'Bouton de navigation des récompenses',
      show_reward_favourite_button: 'Bouton favori des récompenses',
      show_progress_bar_campaigns_on_home_page:
        'Campagnes à barre de progression sur la page d’accueil',
      show_instant_reward_campaigns_on_home_page:
        'Campagnes de récompense instantanée sur la page d’accueil',
      manual_claim_raffle_ticket: 'Réclamation manuelle des tickets de tombola'
    },
    Toasts: {
      Saved: 'Paramètres de contrôle enregistrés',
      SaveFailed: 'Impossible d’enregistrer les paramètres de contrôle. Veuillez réessayer.'
    },
    Load: {
      Failed: 'Impossible de charger les paramètres de contrôle.',
      Retry: 'Réessayer'
    }
  },
  [GuardKey]: {
    Title: 'Abandonner les modifications non enregistrées ?',
    Content:
      'Vous avez des modifications non enregistrées. Elles seront perdues si vous quittez cet onglet.',
    Discard: 'Abandonner',
    KeepEditing: 'Continuer la modification'
  }
};
